export default "__VITE_ASSET__DjJz5Qnr__"